import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body py-4" }
const _hoisted_5 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_6 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = { class: "" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, null, -1)

import { onMounted, ref } from "vue";
import AccountService from "../services/AccountService";
import { TransactionAccountType } from "@/core/types/StateInfos";
import TableFooter from "@/components/TableFooter.vue";
import LoadingRing from "@/components/LoadingRing.vue";
import NoDataBox from "@/components/NoDataBox.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import BalanceShow from "@/components/BalanceShow.vue";
import { ActionType } from "@/core/types/Actions";
import TimeShow from "@/components/TimeShow.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountDetailTransactions',
  props: {
    accountId: {},
    partyId: {}
  },
  setup(__props: any) {

const props = __props;



const isLoading = ref(true);

const criteria = ref({
  accountId: props.accountId,
} as any);

const transactions = ref(Array<any>());

const fetchData = async (_page: number) => {
  criteria.value.page = _page;
  try {
    const responseBody = await AccountService.queryTransactions(criteria.value);
    criteria.value = responseBody.criteria;
    transactions.value = responseBody.data;
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};

onMounted(async () => {
  await fetchData(1);
});

const pageChange = (newPage: number) => {
  fetchData(newPage);
};

return (_ctx: any,_cache: any) => {
  const _component_UserInfo = _resolveComponent("UserInfo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("title.transferHistory")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("table", _hoisted_5, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_6, [
            _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("fields.client")), 1),
            _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t("fields.source")), 1),
            _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("fields.target")), 1),
            _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("fields.amount")), 1),
            _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("fields.createdOn")), 1)
          ])
        ]),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
              _createVNode(LoadingRing)
            ]))
          : (!isLoading.value && transactions.value.length === 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_13, [
                _createVNode(NoDataBox)
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transactions.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", _hoisted_15, [
                      (item.user)
                        ? (_openBlock(), _createBlock(_component_UserInfo, {
                            key: 0,
                            user: item.user,
                            class: "me-2"
                          }, null, 8, ["user"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_16, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t(`type.transactionAccount.${item.sourceAccountType}`) +
                  " " +
                  (item.sourceAccountType === _unref(TransactionAccountType).Wallet
                    ? _ctx.$t(`type.currency.${item.currencyId}`)
                    : item.sourceAccountNumber)), 1),
                      _createElementVNode("div", null, [
                        _createVNode(BalanceShow, {
                          class: "fw-bold",
                          balance: item.sourceAccountBalanceInCents,
                          "currency-id": item.currencyId
                        }, null, 8, ["balance", "currency-id"])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_17, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t(`type.transactionAccount.${item.targetAccountType}`) +
                  " " +
                  (item.targetAccountType ===
                  _unref(TransactionAccountType).TradeAccount
                    ? item.targetAccountNumber
                    : _ctx.$t(`type.currency.${item.currencyId}`))), 1),
                      _createElementVNode("div", null, [
                        _createVNode(BalanceShow, {
                          class: "fw-bold",
                          balance: item.targetAccountBalanceInCents,
                          "currency-id": item.currencyId
                        }, null, 8, ["balance", "currency-id"])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_18, [
                      _createVNode(BalanceShow, {
                        class: "fw-bold",
                        balance: item.amount,
                        "currency-id": item.currencyId
                      }, null, 8, ["balance", "currency-id"])
                    ]),
                    _createElementVNode("td", _hoisted_19, [
                      _createVNode(TimeShow, {
                        "date-iso-string": item.createdOn
                      }, null, 8, ["date-iso-string"])
                    ]),
                    _hoisted_20
                  ]))
                }), 128))
              ]))
      ]),
      _createVNode(TableFooter, {
        onPageChange: pageChange,
        criteria: criteria.value
      }, null, 8, ["criteria"])
    ])
  ]))
}
}

})